/**
 * Generates initials from a user's first and last name, or from a full name string
 * @param firstNameOrFullName - The user's first name or full name string
 * @param lastName - The user's last name (optional if using full name)
 * @returns The initials in uppercase (e.g., "JD"), or "U" if no names provided
 * @example
 * // With separate first and last names
 * getUserInitials("John", "Doe") // "JD"
 * getUserInitials("John", null) // "J"
 *
 * // With full name string
 * getUserInitials("John Doe") // "JD"
 * getUserInitials("John") // "J"
 */
export const getUserInitials = (
  firstNameOrFullName: string | null | undefined,
  lastName?: string | null | undefined,
): string => {
  // If lastName is provided, use the two-parameter version
  if (lastName !== undefined) {
    const initials = [firstNameOrFullName?.trim()?.[0], lastName?.trim()?.[0]].filter(Boolean).join("").toUpperCase();
    return initials || "U";
  }

  // Otherwise, treat the first parameter as a full name string
  const fullName = firstNameOrFullName || "";
  const initials = fullName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
  return initials || "U";
};
